import {
  CREATE_PRODUCT_MANIP,
  DELETE_PRODUCT_MANIP,
  UPDATE_PRODUCT_MANIP,
} from '../actions/manips';

export default function(state = [], action) {
  switch (action.type) {
    case CREATE_PRODUCT_MANIP:
    case UPDATE_PRODUCT_MANIP:
    case DELETE_PRODUCT_MANIP:
      return true;
    default:
      return state;
  }
}

export const getProductManips = state => state.manips.productmanips.length;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/productmanips.js